import React, {FC} from 'react'

import cn from 'classnames/bind'

import LandingsTitle from 'components/blocks/LandingsTitle'
import PortableBlocks from 'components/blocks/PortableBlocks'
import {Col, Container, Row} from 'components/elements/grid'
import {IW2Content} from 'pages/make-your-w2'

import s from './W2HowToGet.module.scss'
const cx = cn.bind(s)

interface IW2HowToGetProps {
	className?: string
	content: IW2Content['howToGet']
}

/** W2HowToGet block component */
const W2HowToGet: FC<IW2HowToGetProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle className={s.title} title={content?.title} subtitle={content?.subtitle} />
				<Row>
					<Col xl={{span: 10, offset: 1}}>
						{content?.items?.map((item) => (
							<div className={s.item} key={item._key}>
								<p className={cx('h3', 'item__title')}>{item.title}</p>
								{item.description && (
									<PortableBlocks blockContent={item.description} className={'item__description'} />
								)}
							</div>
						))}
					</Col>
				</Row>
			</Container>
		</div>
	)
}

W2HowToGet.displayName = 'W2HowToGet'

export default W2HowToGet
